var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLivceChatCameraIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "camera-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.644,
    height: 23.174,
    viewBox: "0 0 22.644 23.174",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1939",
    "data-name": "Rectangle 1939",
    width: 22.644,
    height: 23.174,
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2280",
    "data-name": "Path 2280",
    d: "M12.359,11a2.359,2.359,0,1,0,2.359,2.359A2.359,2.359,0,0,0,12.359,11Z",
    transform: "translate(-1.872 -1.273)",
    fill: "#323232",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2281",
    "data-name": "Path 2281",
    d: "M21.009,9.208c0,.032,0,.064,0,.1V15.47a17.623,17.623,0,0,1-.078,2.159A2.6,2.6,0,0,1,18.469,20.1a17.4,17.4,0,0,1-2.15.078H6.69A17.4,17.4,0,0,1,4.54,20.1a2.818,2.818,0,0,1-1.7-.76,2.841,2.841,0,0,1-.757-1.712A17.623,17.623,0,0,1,2,15.47V9.3q0-.049,0-.1a5.048,5.048,0,0,1,.08-1.155,2.857,2.857,0,0,1,2.1-2.108A4.986,4.986,0,0,1,5.33,5.863h.1a3.653,3.653,0,0,0,.449-.011.949.949,0,0,0,.563-.3A3.685,3.685,0,0,0,6.7,5.181l.215-.324.065-.1a4.576,4.576,0,0,1,.976-1.181A2.848,2.848,0,0,1,8.73,3.16,4.544,4.544,0,0,1,10.25,3h2.509a4.544,4.544,0,0,1,1.52.16,2.848,2.848,0,0,1,.777.418,4.579,4.579,0,0,1,.976,1.181l.065.1.215.324a3.677,3.677,0,0,0,.258.369.949.949,0,0,0,.563.3,3.652,3.652,0,0,0,.449.011h.1a4.985,4.985,0,0,1,1.151.081,2.857,2.857,0,0,1,2.1,2.108A5.051,5.051,0,0,1,21.009,9.208ZM7.7,12.544a3.8,3.8,0,1,1,3.8,3.818A3.81,3.81,0,0,1,7.7,12.544Z",
    transform: "translate(-1.231 -0.573)",
    fill: "#323232",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivceChatCameraIcon);
export default __webpack_public_path__ + "static/media/livce-chat-camera-icon.00dc82440d8db428b376c97d22e9f621.svg";
export { ForwardRef as ReactComponent };